var _rect, _path, _mask, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg403(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 217,
    style: {
      height: 217,
      width: 184
    },
    viewBox: "",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 64.2656,
    width: 179.902,
    height: 150.732,
    rx: 21,
    fill: "white",
    stroke: "black",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.744 46.2927V63.4512H48.1587V46.2927C48.1587 22.1067 67.7653 2.5 91.9514 2.5C116.137 2.5 135.744 22.1067 135.744 46.2927Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.464 162.407C106.04 159.477 109.073 154.348 109.073 148.511C109.073 139.405 101.691 132.023 92.5855 132.023C83.4795 132.023 76.0977 139.405 76.0977 148.511C76.0977 154.349 79.1311 159.477 83.7076 162.407V183.367C83.7076 187.233 86.8416 190.367 90.7076 190.367H94.4637C98.3297 190.367 101.464 187.233 101.464 183.367V162.407Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.464 162.407C106.04 159.477 109.073 154.348 109.073 148.511C109.073 139.405 101.691 132.023 92.5855 132.023C83.4795 132.023 76.0977 139.405 76.0977 148.511C76.0977 154.349 79.1311 159.477 83.7076 162.407V183.367C83.7076 187.233 86.8416 190.367 90.7076 190.367H94.4637C98.3297 190.367 101.464 187.233 101.464 183.367V162.407Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.464 162.407L99.8461 159.88L98.4637 160.766V162.407H101.464ZM83.7076 162.407H86.7076V160.766L85.3251 159.881L83.7076 162.407ZM106.073 148.511C106.073 153.283 103.597 157.479 99.8461 159.88L103.081 164.934C108.483 161.475 112.073 155.414 112.073 148.511H106.073ZM92.5855 135.023C100.035 135.023 106.073 141.062 106.073 148.511H112.073C112.073 137.748 103.348 129.023 92.5855 129.023V135.023ZM79.0977 148.511C79.0977 141.062 85.1364 135.023 92.5855 135.023V129.023C81.8226 129.023 73.0977 137.748 73.0977 148.511H79.0977ZM85.3251 159.881C81.5736 157.479 79.0977 153.283 79.0977 148.511H73.0977C73.0977 155.414 76.6886 161.476 82.09 164.934L85.3251 159.881ZM86.7076 183.367V162.407H80.7076V183.367H86.7076ZM90.7076 187.367C88.4984 187.367 86.7076 185.576 86.7076 183.367H80.7076C80.7076 188.89 85.1847 193.367 90.7076 193.367V187.367ZM94.4637 187.367H90.7076V193.367H94.4637V187.367ZM98.4637 183.367C98.4637 185.576 96.6728 187.367 94.4637 187.367V193.367C99.9865 193.367 104.464 188.89 104.464 183.367H98.4637ZM98.4637 162.407V183.367H104.464V162.407H98.4637Z",
    fill: "black",
    mask: "url(#path-3-inside-1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg403);
export default __webpack_public_path__ + "static/media/403.33f31303.svg";
export { ForwardRef as ReactComponent };